import { CreateProjectDtoLabelEnum } from 'src/Services/API/generated/api';

export type ProjectLabel = CreateProjectDtoLabelEnum;
export const ProjectLabel = CreateProjectDtoLabelEnum;

export const PROJECT_LABEL_COLORS: Record<ProjectLabel, { color: string; name: string }> = {
  [ProjectLabel.Red]: { color: '#FF3B30', name: 'Rouge' },
  [ProjectLabel.Orange]: { color: '#FF9500', name: 'Orange' },
  [ProjectLabel.Yellow]: { color: '#FFCC00', name: 'Jaune' },
  [ProjectLabel.Green]: { color: '#34C759', name: 'Vert' },
  [ProjectLabel.Blue]: { color: '#007AFF', name: 'Bleu' },
  [ProjectLabel.Purple]: { color: '#AF52DE', name: 'Violet' },
  [ProjectLabel.Gray]: { color: '#8E8E93', name: 'Gris' },
};

export const PROJECT_LABELS_LIST = Object.entries(PROJECT_LABEL_COLORS).map(([key, value]) => ({
  value: key as ProjectLabel,
  ...value,
}));
